import { render, staticRenderFns } from "./AddPageDetail.vue?vue&type=template&id=3c817cde"
var script = {}
import style0 from "./AddPageDetail.vue?vue&type=style&index=0&id=3c817cde&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports